import {
  GoHome,
  GoGear,
  GoDeviceDesktop,
  GoPackage,
  GoSync,
  GoBroadcast,
  GoRepoForked,
  GoShieldCheck,
  GoPeople,
  GoPerson,
  GoClock,
  GoGlobe,
  GoTrash,
  GoBell,
  GoLock,
  GoUpload,
  GoKey,
  GoInbox,
  GoVersions,
  GoStack,
  GoDownload,
  GoCalendar,
  GoHourglass,
  GoArrowSwitch,
  GoGraph,
  GoTools,
  GoChecklist,
  GoHistory,
  GoListUnordered,
  GoPulse,
  GoCommentDiscussion,
  GoLightBulb,
} from "react-icons/go"

const MENU = [
  {
    title: "Dashboard",
    Link: "/dashboard",
    icon: <GoHome />,
    access: [{ label: "View", value: "dashboard" }],
  },
  {
    title: "Assistant",
    Link: "/assistant",
    icon: <GoLightBulb />,
    access: [{ label: "View", value: "dashboard" }],
  },
  {
    title: "Operations",
    icon: <GoGear />,
    children: [
      {
        title: "Schedules",
        Link: "/schedules",
        icon: <GoCalendar />,
        access: [
          { label: "View", value: "schedules" },
          { label: "Add", value: "add-schedule" },
          { label: "Edit", value: "edit-schedule/:id" },
        ],
      },
      {
        title: "Deployments",
        Link: "/deployments",
        icon: <GoChecklist />,
        access: [{ label: "View", value: "schedules" }],
      },
      {
        title: "Maintenance",
        Link: "/maintenance",
        icon: <GoHourglass />,
        access: [{ label: "View", value: "maintenance" }],
      },
      {
        title: "Security training",
        Link: "/training",
        icon: <GoChecklist />,
        access: [
          { label: "View", value: "broadcasts" },
          { label: "View", value: "create-broadcasts" },
          { label: "View", value: "devices" },
        ],
      },
      {
        title: "Desktop broadcasts",
        Link: "/desktop-broadcasts",
        icon: <GoBroadcast />,
        access: [
          { label: "View", value: "broadcasts" },
          { label: "Create", value: "create-broadcasts" },
          { label: "View", value: "maintenance" },
          { label: "View", value: "inactivity-notification-settings" },
          { label: "View", value: "schedules" },
        ],
      },
      {
        title: "Corporate wallpaper",
        Link: "/corporate-wallpaper",
        icon: <GoDeviceDesktop />,
        access: [
          { label: "View", value: "broadcasts" },
          { label: "View", value: "maintenance" },
          { label: "View", value: "schedules" },
        ],
      },
      {
        title: "Time Tracker policy",
        Link: "/time-tracker-policy",
        icon: <GoClock />,
        access: [
          { label: "View", value: "broadcasts" },
          { label: "View", value: "maintenance" },
          { label: "View", value: "schedules" },
        ],
      },
      {
        title: "WireGuard VPN",
        Link: "/wireguard-policy",
        icon: <GoLock />,
        access: [
          { label: "View", value: "broadcasts" },
          { label: "View", value: "maintenance" },
          { label: "View", value: "schedules" },
        ],
      },
      {
        title: "Notifications",
        Link: "/inactivity-notification-settings",
        icon: <GoBell />,
        access: [{ label: "View", value: "inactivity-notification-settings" }],
      },
      {
        title: "App updates",
        Link: "/app-management",
        icon: <GoArrowSwitch />,
        access: [{ label: "View", value: "app-management" }],
      },
      {
        title: "Windows updates",
        Link: "/patches",
        icon: <GoSync />,
        access: [{ label: "View", value: "patches" }],
      },
      {
        title: "WSUS status",
        Link: "/wsus-status",
        icon: <GoPulse />,
        access: [{ label: "View", value: "patches" }],
      },
      {
        title: "Device patches",
        Link: "/device-patches",
        icon: <GoListUnordered />,
        access: [{ label: "View", value: "patches" }],
      },
      {
        title: "Vulnerabilities",
        Link: "/vulnerabilities",
        icon: <GoShieldCheck />,
        access: [{ label: "View", value: "patches" }],
      },
      {
        title: "OS updates",
        Link: "/os-updates",
        icon: <GoDownload />,
        access: [{ label: "View", value: "patches" }],
      },
      {
        title: "Catalog",
        Link: "/global-patches",
        icon: <GoGlobe />,
        access: [{ label: "View", value: "global-patches" }],
      },
      {
        title: "Patch reports",
        Link: "/patch-reports",
        icon: <GoGraph />,
        access: [{ label: "View", value: "patch-reports" }],
      },
      {
        title: "Software reports",
        Link: "/software-reports",
        icon: <GoChecklist />,
        access: [
          { label: "View", value: "software-reports" },
          { label: "View", value: "patch-reports" },
        ],
      },
    ],
  },
  {
    title: "Devices",
    icon: <GoDeviceDesktop />,
    children: [
      {
        title: "Devices",
        Link: "/devices",
        icon: <GoDeviceDesktop />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Devices",
        Link: "/devices",
        icon: <GoDeviceDesktop />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Training",
        Link: "/training",
        icon: <GoChecklist />,
        access: [
          { label: "View", value: "u-devices" },
          { label: "View", value: "my-profile" },
        ],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Assets",
        Link: "/assets",
        icon: <GoStack />,
        access: [
          { label: "View", value: "devices" },
          { label: "View", value: "u-devices" },
        ],
      },
      {
        title: "Tracker",
        Link: "/device-tracker",
        icon: <GoGlobe />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Tracker",
        Link: "/device-tracker",
        icon: <GoGlobe />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Agent health",
        Link: "/agent-health",
        icon: <GoPulse />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Agent health",
        Link: "/agent-health",
        icon: <GoPulse />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Performance health",
        Link: "/performance-health",
        icon: <GoGraph />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Performance health",
        Link: "/performance-health",
        icon: <GoGraph />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Battery report",
        Link: "/battery-report",
        icon: <GoGraph />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Battery report",
        Link: "/battery-report",
        icon: <GoGraph />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Groups",
        Link: "/group-devices",
        icon: <GoRepoForked />,
        access: [
          { label: "View", value: "group-devices" },
          { label: "Add", value: "add/group-devices" },
          { label: "Edit", value: "edit/group-devices/:id" },
        ],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Groups",
        Link: "/group-devices",
        icon: <GoPeople />,
        access: [
          { label: "View", value: "u-group-devices" },
          { label: "Add", value: "add/group-devices" },
          { label: "Edit", value: "edit/group-devices/:id" },
        ],
        dontShowFor: ["network-admin", "user"],
      },
      {
        title: "Remote support",
        Link: "/remote-support",
        icon: <GoBroadcast />,
        access: [{ label: "View", value: "remote-support" }],
      },
      {
        title: "Help desk",
        Link: "/help-desk",
        icon: <GoCommentDiscussion />,
        access: [{ label: "View", value: "remote-support" }],
      },
      {
        title: "Reboot",
        Link: "/reboot-devices",
        icon: <GoHistory />,
        access: [{ label: "View", value: "reboot-devices" }],
      },
      {
        title: "Left on overnight",
        Link: "/left-on-devices",
        icon: <GoHourglass />,
        access: [{ label: "View", value: "devices" }],
        dontShowFor: ["admin", "user"],
      },
      {
        title: "Left on overnight",
        Link: "/left-on-devices",
        icon: <GoHourglass />,
        access: [{ label: "View", value: "u-devices" }],
        dontShowFor: ["network-admin"],
      },
      {
        title: "Deleted",
        Link: "/deleted-devices",
        icon: <GoTrash />,
        access: [{ label: "View", value: "deleted-devices" }],
      },
      {
        title: "Enrollment",
        Link: "/device-enrollment",
        icon: <GoLock />,
        access: [{ label: "View", value: "device-enrollment" }],
      },
    ],
  },
  {
    title: "Apps",
    icon: <GoPackage />,
    children: [
      {
        title: "Inventory",
        Link: "/all-apps",
        icon: <GoStack />,
        access: [{ label: "View", value: "all-apps" }],
      },
      {
        title: "Bundles",
        Link: "/app-bundles",
        icon: <GoVersions />,
        access: [
          { label: "View", value: "app-bundles" },
          { label: "Add", value: "add-app-bundles" },
          { label: "Edit", value: "edit-app-bundles/:id" },
        ],
      },
      {
        title: "Requests",
        Link: "/app-requests",
        icon: <GoInbox />,
        access: [{ label: "View", value: "app-requests" }],
      },
      {
        title: "Request policy",
        Link: "/catalog-policy",
        icon: <GoLock />,
        access: [
          { label: "View", value: "catalog-policy" },
          { label: "View", value: "app-requests" },
        ],
        dontShowFor: ["user"],
      },
      {
        title: "App control",
        Link: "/app-control",
        icon: <GoShieldCheck />,
        access: [
          { label: "View", value: "app-control" },
          { label: "View", value: "catalog-policy" },
          { label: "View", value: "app-requests" },
          { label: "View", value: "all-apps" },
        ],
        dontShowFor: ["user"],
      },
      {
        title: "My requests",
        Link: "/user-app_installation-request",
        icon: <GoDownload />,
        access: [{ label: "View", value: "user-app_installation-request" }],
        dontShowFor: ["network-admin"],
      },
    ],
  },
  {
    title: "Tasks",
    icon: <GoListUnordered />,
    children: [
      {
        title: "Custom tasks",
        Link: "/custom-task",
        icon: <GoTools />,
        access: [
          { label: "View", value: "custom-task" },
          { label: "Add", value: "add-customtask" },
          { label: "Edit", value: "edit-customtask/:id" },
        ],
      },
      {
        title: "Scripts",
        Link: "/scripts",
        icon: <GoTools />,
        access: [
          { label: "View", value: "scripts" },
          { label: "Add", value: "add-script" },
          { label: "Edit", value: "edit-script/:id" },
        ],
      },
      {
        title: "Jobs",
        Link: "/clear-tasks",
        icon: <GoInbox />,
        access: [{ label: "View", value: "clear-tasks" }],
      },
    ],
  },
  {
    title: "Security",
    icon: <GoShieldCheck />,
    children: [
      {
        title: "Device controls",
        Link: "/security-policies",
        icon: <GoShieldCheck />,
        access: [{ label: "View", value: "security-policies" }],
      },
      {
        title: "Encryption keys",
        Link: "/encryption-keys",
        icon: <GoLock />,
        access: [{ label: "View", value: "security-policies" }],
      },
      {
        title: "LAPS",
        Link: "/laps",
        icon: <GoLock />,
        access: [{ label: "View", value: "security-policies" }],
      },
      {
        title: "Configuration profiles",
        Link: "/security-templates",
        icon: <GoLock />,
        access: [{ label: "View", value: "security-templates" }],
      },
      {
        title: "Compliance policies",
        Link: "/compliance-policies",
        icon: <GoShieldCheck />,
        access: [
          { label: "View", value: "compliance-policies" },
          { label: "View", value: "security-templates" },
        ],
      },
    ],
  },
  {
    title: "Users",
    icon: <GoPeople />,
    children: [
      {
        title: "All users",
        Link: "/users",
        icon: <GoPerson />,
        access: [{ label: "View", value: "users" }],
      },
      {
        title: "User logins",
        Link: "/user-logins",
        icon: <GoLock />,
        access: [
          { label: "View", value: "users" },
          { label: "View", value: "users-activity" },
        ],
      },
      {
        title: "Activity",
        Link: "/users-activity",
        icon: <GoClock />,
        access: [{ label: "View", value: "users-activity" }],
      },
      {
        title: "Bulk register",
        Link: "/bulk-register",
        icon: <GoUpload />,
        access: [{ label: "View", value: "bulk-register" }],
      },
    ],
  },
  {
    title: "Roles",
    Link: "/roles",
    icon: <GoKey />,
    access: [
      { label: "View", value: "roles" },
      { label: "Edit", value: "roles/:id" },
    ],
    dontShowFor: ["user"],
  },
]

export default MENU
